import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api/admin/admin-mistake`;

const getAdminMistakes = async (params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    return await axios.get(API_URL + (queryString ? `?${queryString}` : ''));
};

const getAdminMistake = async (id) => {
    return await axios.get(`${API_URL}/${id}`);
};

const addAdminMistake = async (data) => {
    return await axios.post(API_URL, data);
};

const editAdminMistake = async (id, data) => {
    return await axios.put(`${API_URL}/${id}`, data);
};

const deleteAdminMistake = async (id) => {
    return await axios.delete(`${API_URL}/${id}`);
};

const resolveOrderByUrl = async (url) => {
    const queryString = new URLSearchParams({ url }).toString();
    return await axios.get(`${API_URL}/resolve-order-by-url?${queryString}`);
};

const AdminMistakeService = {
    getAdminMistakes,
    getAdminMistake,
    addAdminMistake,
    editAdminMistake,
    deleteAdminMistake,
    resolveOrderByUrl
};

export default AdminMistakeService;
